import { createRef, useContext, useEffect, useMemo, useRef, useState } from 'react';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import styles from './MonthlyReportSections.module.scss';
import { HiChevronLeft as LeftChevron, HiChevronRight as RightChevron, HiPencil as PencilIcon } from 'react-icons/hi';
import { monthlyReportStepperList } from '../MonthlyReportHome/monthlyReport.helper';
import { Route, Routes, useLocation, useNavigate, useOutletContext } from 'react-router';
import { ApplicationContextType, LendingStatus, monthlyReportRoutes, MonthlyReportSteps, MonthlyReportStepsTitle, StatementStepType, UnderwritingFormStatus, UnderwritingSteps, uploadStates } from '../../../interfaces/interfaces';
import { CustomStepIcon, CustomStepper, CustomStepperConnector } from '../components/stepper/stepper.helper';
import { MonthlyReportFormContext } from '../context/MonthlyReportFormContext';
import { Step, StepLabel } from '@mui/material';
import ConnectAccounts from '../../Underwriting/ConnectAccounts/ConnectAccounts';
import SalesMarketing from '../components/SalesMarketing/SalesMarketing';
import GST from '../components/GST/gst';
import MonthlyReportBankStatement from '../BankStatement/MonthlyReportBankStatement';
import { getIn } from 'final-form';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { RestS } from '../../../rest/rest-service';
import { RecipientList } from '../components/RecipientList/RecipientList';
import { BiSupport } from 'react-icons/bi';
import { LiveSupport } from '../components/LiveSupport/LiveSupport';
import ModalDialog from '../../../components/common/Modal';
import { BsFillExclamationCircleFill } from 'react-icons/bs';
import BusinessUpdates from '../BusinessUpdates/BusinessUpdates';
import ChecklistPage from '../../Underwriting/Checklist/Checklist';
import moment from 'moment';
import usePageTitle from '../../../components/Hooks/usePageTitle';
import HeaderTitle from '../../../components/common/HeaderTitle';


const MonthlyReportSections = () => {
    const [stepperList, setStepperList] = useState(monthlyReportStepperList);
    const [activeStep, setActiveStep] = useState(0);

    const { formData, extraFormDetails, setFormData, formStepsValidity, handleAndSetFormStatuses, fetchUnderwritingFileJobs, underwritingFileJobs, formCompleteStatus } = useContext(MonthlyReportFormContext);
    const [formPristine, setFormPristine] = useState(false);
    const [isSupportOpen, setIsSupportOpen] = useState(false)
    const [isSubmitReportOpen, setIsSubmitReportOpen] = useState(false);
    const [showConnectAccountsWarning, setShowConnectAccountsWarning] = useState(false);

    const { setHeaderContent, resetHeaderContent } = useOutletContext<any>();

    const pageTitle = usePageTitle('Monthly Report | Merito');

    useEffect(() => {
        setHeaderContent(
            <HeaderTitle isNav={false} headerTitle={`Monthly Report - ${moment(extraFormDetails?.monthYear, "MM-YYYY").format("MMMM YYYY")}`} />
        );
        return () => {
            resetHeaderContent();
            pageTitle('')
        };
    }, []);

    const [showSaveWarning, setShowSaveWarning] = useState({
        state: false,
        newDocIds: null,
    });

    const [submitWarning, setSubmitWarning] = useState({
        state: false,
        formValues: null,
    });
    const [navigateToState, setNavigateToState] = useState({
        stepIndex: null,
        link: ''
    });
    const [submitLoading, setSubmitLoading] = useState(false);
    const { pathname } = useLocation();



    const stepperLocationObj = useMemo(() => {
        return stepperList.reduce((prev, curVal, index) => {
            prev[curVal.link.toLowerCase()] = {
                ...curVal,
                stepIndex: index
            }
            return prev;
        }, {})
    }, [stepperList])


    useEffect(() => {
        let activeStepIndex = stepperLocationObj[pathname.toLowerCase()];
        if (activeStepIndex != undefined) {
            setActiveStep(activeStepIndex?.stepIndex)
        } else {
            setActiveStep(0)
        }
    }, [pathname]);

    const isChecklistPage = pathname == monthlyReportRoutes.checklist ? true : false;


    const formSectionRefs = useRef<any>({
        [MonthlyReportSteps.connectAccounts]: createRef(),
        [MonthlyReportSteps.bankStatement]: createRef(),
        [MonthlyReportSteps.salesMarketing]: createRef(),
        [MonthlyReportSteps.businessUpdates]: createRef(),
        [MonthlyReportSteps.gst]: createRef(),
        [MonthlyReportSteps.recipients]: createRef(),
    });


    const handleBankStatementWarning = (formValues: any, deleteDocIds: []) => {
        // console.log('bankStatementValues', bankStatementValues);
        // console.log('statementAnalysisJobs', statementAnalysisJobs);
        const { values } = formValues;
        const bankStatementData = values?.bankStatements;
        let otherError = false;
        let warningShown = false;
        const allBankStatementUploadedJobs = getIn(underwritingFileJobs, `${MonthlyReportSteps.bankStatement}`);
        let accountIndex = 0;
        for (const statementData of bankStatementData) {

            if (statementData?.statementType == StatementStepType.pdf_upload) {
                let statementIndex = 0;
                let isErrorShown = false;
                for (const statements of statementData?.statements) {
                    const uploadedFile = allBankStatementUploadedJobs[`${statementData?.statementJobId}.statements[${statementIndex}]`];
                    if (uploadedFile) {
                        const requriePassword = uploadedFile?.status == uploadStates.requiredPassword;
                        if (requriePassword) {
                            setSubmitWarning({
                                state: true,
                                formValues: formValues,
                                // newDocIds: bankStatementValues?.newDocIds
                            })
                            isErrorShown = true;
                            otherError = true;
                            break;
                        }
                    }
                    statementIndex++;
                }
                if (isErrorShown) {
                    otherError = true;
                    warningShown = true;
                    break;
                }
            }
        }
        console.log('otherError', otherError);
        accountIndex++;
        return warningShown;
    }

    const navigate = useNavigate();

    const handleRandomNavigation = async (navigateToObj = null) => {
        if (isChecklistPage) {
            navigate(stepperList[stepperList.length - 1].link);
            return;
        }
        let navigateTo = {
            stepIndex: activeStep == 0 ? null : activeStep - 1,
            link: activeStep == 0 ? monthlyReportRoutes.monthlyReportHome : stepperList[activeStep - 1].link
        }
        if (navigateToObj) {
            navigateTo = navigateToObj;
        }
        const isLastStep = stepperList.length - 1 == activeStep;
        if (activeStep == 0) {
            navigate(navigateTo.link);
            if (navigateToObj) {
                setActiveStep(navigateTo.stepIndex);
            }
        } else {
            const currentStep = activeStep;
            const currentStepObj = stepperList[currentStep]
            const nextStep = isLastStep ? null : stepperList[currentStep + 1];
            // navigate(navigateTo.link);
            // setActiveStep(navigateTo.stepIndex);
            if (currentStepObj?.name == MonthlyReportSteps.recipients) {
                setActiveStep(navigateTo.stepIndex);
                navigate(navigateTo.link)
                return;
            }
            const currentFormValues = await formSectionRefs?.current[currentStepObj?.name].current.submitForm();
            if (currentStepObj.name == MonthlyReportSteps.salesMarketing && !currentFormValues?.pristine) {
                setNavigateToState({
                    stepIndex: navigateTo.stepIndex,
                    link: navigateTo.link
                })
                setShowSaveWarning({
                    state: true,
                    newDocIds: currentFormValues?.newDocIds
                });
            } else if (!formPristine && currentStepObj.name != MonthlyReportSteps.salesMarketing) {
                setNavigateToState({
                    stepIndex: navigateTo.stepIndex,
                    link: navigateTo.link
                })
                setShowSaveWarning({
                    state: true,
                    newDocIds: currentFormValues?.newDocIds
                });
            } else {
                setActiveStep(navigateTo.stepIndex);
                navigate(navigateTo.link)
            }
        }
    }

    const handleNextStep = async () => {
        const isLastStep = stepperList.length - 1 == activeStep;
        const currentStep = activeStep;
        const currentStepObj = stepperList[currentStep];
        const nextStep = isLastStep ? null : stepperList[currentStep + 1];

        const currentFormValues = await formSectionRefs?.current[currentStepObj?.name].current?.submitForm();

        if (activeStep == 0) {
            setShowConnectAccountsWarning(true);
            return
        }

        // console.log('currentFormValues', currentFormValues);




        if (!currentFormValues?.success && !isLastStep) {
            // console.log('invalid values', currentFormValues);
            if (currentStepObj?.name == MonthlyReportSteps.bankStatement) {
                console.log('currentFormValues', currentFormValues);
                const isWarningshow = handleBankStatementWarning(currentFormValues, currentFormValues?.deleteDocIds);

                if (isWarningshow) return {}
            }
            setSubmitWarning({
                state: true,
                formValues: currentFormValues
            })
            return {};
        } else {
            if (currentStepObj.name == MonthlyReportSteps.bankStatement) {
                console.log('coming inside this step')
                const isWarningShow = handleBankStatementWarning(currentFormValues, currentFormValues?.deleteDocIds);
                console.log('isWarningShow', isWarningShow);
            } else {
                let submitFormData = {
                    data: currentStepObj?.name == MonthlyReportSteps.recipients || currentStepObj?.name == MonthlyReportSteps.connectAccounts ? {
                        ...formData,
                    } : {
                        // ...formData,
                        ...currentFormValues?.values,
                    },
                    step: currentStepObj.name,
                    // applicationStatus: isLastStep ? LendingStatus.PENDING_APPROVAL : LendingStatus.IN_PROGRESS,
                    applicationStatus: LendingStatus.IN_PROGRESS,
                    deleteDocIds: currentFormValues?.deleteDocIds ?? [],
                    monthYear: extraFormDetails?.monthYear,
                }
                if (isLastStep) {
                    onSubmitForm(submitFormData, isLastStep)
                    return;
                }

                if (!currentFormValues?.pristine || formCompleteStatus[currentStepObj.name] == UnderwritingFormStatus.INCOMPLETE) {
                    onSubmitForm(submitFormData, isLastStep)
                }
            }
        }

        if (nextStep) {
            setActiveStep(currentStep + 1);
            navigate(nextStep.link);
        }
    }

    const handleOnDiscardChanges = async (newDocIds) => {
        try {
            if (newDocIds && newDocIds.length) return;
            const response = await RestS.deleteUploadedJob({
                deleteDocIds: newDocIds
            });
            fetchUnderwritingFileJobs();
        } catch (error) {
            console.log('error', error)
        }
    }
    const onSubmitForm = async (submitFormData, isLastStep = false) => {
        try {
            if (isLastStep) setSubmitLoading(true);
            setFormData(submitFormData?.data);
            // Drop bank-statement accounts with no uploaded statements so this
            // submit path never creates a statement analysis job with an empty
            // uploadedDocIds (mirrors the sanitization in useAutoSave.saveToDB).
            const sanitizedSubmitFormData = submitFormData?.data?.bankStatements
                ? {
                    ...submitFormData,
                    data: {
                        ...submitFormData.data,
                        bankStatements: submitFormData.data.bankStatements.filter(
                            (bankStatement: any) => bankStatement?.statements?.length,
                        ),
                    },
                }
                : submitFormData;
            // await delaySubmitting()
            const data: any = await RestS.submitMonthlyReportFormData(sanitizedSubmitFormData);
            // const data: any = await RestS.
            // submitting monthly report data
            handleAndSetFormStatuses(data?.formStatuses)
            setFormData(data?.formData['data']);
            if (isLastStep) {
                console.log('coming in last step')
                navigate(monthlyReportRoutes.checklist)
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setSubmitLoading(false);
        }
    }

    const submitFormData = () => {
        const currentStep = activeStep;
        const currentStepObj = stepperList[currentStep]
        const nextStep = stepperList[currentStep + 1];
        // console.log('currentStep', currentStep, 'activeStep', activeStep);
        if (currentStep == 0) {
            let submitFormData = {
                data: {
                    ...formData,
                    accountConnectConfirmation: true,
                },
                step: currentStepObj.name,
                monthYear: extraFormDetails?.monthYear,
            }
            if (formData['accountConnectConfirmation'] == undefined || !formData['accountConnectConfirmation']) {
                setShowConnectAccountsWarning(false);
                // setFormData({ ...formData, accountConnectConfirmation: true })
                setActiveStep(activeStep + 1);
                navigate(nextStep?.link);
                onSubmitForm(submitFormData);
            } else {
                // setActiveStep(activeStep + 1);
                setShowConnectAccountsWarning(false);
                navigate(nextStep?.link);
                onSubmitForm(submitFormData);
            }
        }
    }


    const submitAfterSaveWarning = (formValues: any) => {
        try {
            const currentStep = activeStep;
            const isLastStep = stepperList.length - 1 == activeStep;
            const currentStepObj = stepperList[currentStep]
            const nextStep = stepperList[currentStep + 1];
            let submitFormData = {
                data: {
                    // ...formData,
                    ...formValues?.values,
                },
                step: currentStepObj.name,
                deleteDocIds: formValues?.deleteDocIds,
                isIncomplete: true,
                monthYear: extraFormDetails?.monthYear,
            }
            setActiveStep(activeStep + 1);
            navigate(nextStep?.link);
            if (!formValues?.pristine || formCompleteStatus[currentStepObj.name] == UnderwritingFormStatus.INCOMPLETE) {
                onSubmitForm(submitFormData, isLastStep)
            }
            // onSubmitForm(submitFormData);
            setSubmitWarning({
                state: false,
                formValues: null,
            })
        } catch (error) {
            console.log('error');
        }
    }



    return (
        <div className={styles.monthlyReportSectionsRootContainer}>
            <div className={styles.actionBtnContainer}>
                <div className={styles.leftContainer}>
                    <MeritoButton
                        type='secondary-1'
                        btnText={'Back'}
                        icon={<LeftChevron />}
                        onClick={() => handleRandomNavigation()}
                    />
                </div>
                <div className={styles.rightContainer}>
                    {isChecklistPage ? null : <MeritoButton
                        type='primary-1'
                        btnText={"Next"}
                        icon={<RightChevron />}
                        isIconToRight={true}
                        onClick={handleNextStep}
                    />}
                </div>
            </div>

            {isChecklistPage ? null : <div className={styles.stepperRootContainer}>
                <CustomStepper connector={<CustomStepperConnector />} alternativeLabel nonLinear activeStep={activeStep}>
                    {stepperList.map((item, index) => {
                        const isCompleted = formCompleteStatus[item?.name] == UnderwritingFormStatus.COMPLETED;
                        return (
                            <Step completed={isCompleted} key={`${item.name}-${index}`} onClick={(e) => {
                                if (activeStep == index) return;
                                handleRandomNavigation({
                                    stepIndex: index,
                                    link: item.link
                                })
                            }}>
                                <StepLabel
                                    style={{ cursor: 'pointer' }}
                                    StepIconComponent={(props) => <CustomStepIcon {...props} disabled={!isCompleted} />}>
                                    <div className={`${styles.customStepLabel} ${activeStep == index ? styles.active : ''}`}>
                                        {item.title}
                                    </div>
                                </StepLabel>
                            </Step>
                        )
                    })}
                </CustomStepper>
            </div>}

            <Routes>
                <Route path={monthlyReportRoutes.connectAccounts.split('/').at(-1)} element={<ConnectAccounts />} />
                <Route path={monthlyReportRoutes.bankStatement.split('/').at(-1)} element={<MonthlyReportBankStatement ref={formSectionRefs?.current[MonthlyReportSteps.bankStatement]} setFormPristine={setFormPristine} />} />
                <Route path={monthlyReportRoutes.salesMarketing.split('/').at(-1)} element={
                    <SalesMarketing ref={formSectionRefs?.current[MonthlyReportSteps.salesMarketing]} />
                    // <div>Sales Marketing</div>
                }
                />
                <Route path={monthlyReportRoutes.businessUpdates.split('/').at(-1)} element={
                    <BusinessUpdates ref={formSectionRefs?.current[MonthlyReportSteps.businessUpdates]} setFormPristine={setFormPristine} />
                } />
                <Route path={monthlyReportRoutes.gst.split('/').at(-1)} element={<GST ref={formSectionRefs?.current[MonthlyReportSteps.gst]} setFormPristine={setFormPristine} formType={ApplicationContextType.monthlyReport} />} />
                <Route path={monthlyReportRoutes.recipients.split('/').at(-1)} element={<RecipientList />} />
                <Route path={monthlyReportRoutes.checklist.split('/').at(-1)} element={
                    <ChecklistPage
                        formType={ApplicationContextType.monthlyReport}
                        stepperList={monthlyReportStepperList.filter((element) => element.name != MonthlyReportSteps.recipients)}
                        monthYear={moment(extraFormDetails?.monthYear, "MM-YYYY").format('MM-YYYY')}
                    />
                } />
            </Routes>


            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={showSaveWarning?.state}
                toggle={() => {
                    setShowSaveWarning({
                        state: false,
                        newDocIds: null,
                    });
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            Unsaved Changes Will Be Lost!
                            <br />
                            <br />
                        </div>
                    </div>

                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => {
                            // setShowSaveWarning(false)
                            // navigat
                            if (navigateToState.stepIndex != null) {
                                setActiveStep(navigateToState.stepIndex);
                                navigate(navigateToState.link);
                            }
                            handleOnDiscardChanges(showSaveWarning?.newDocIds);
                            setShowSaveWarning({
                                state: false,
                                newDocIds: null,
                            });
                        }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Delete Changes'} />
                        <MeritoButton size="lg" onClick={() => {
                            // submitBankStatementData();
                            setShowSaveWarning({
                                state: false,
                                newDocIds: null,
                            });
                        }} isRounded={true} btnType="button" type="primary-1" btnText="Continue Editing" />
                    </div>
                </div>
            </ConfirmDialog>

            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={submitWarning?.state}
                toggle={() => {
                    setSubmitWarning({
                        state: false,
                        formValues: null,
                    });
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            <>
                                Required Details Are Missing!
                            </>
                        </div>
                        <div className={styles.subTitle}>
                            Do you want to proceed anyway?
                        </div>
                    </div>

                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => {
                            // setShowBankStatementWarning({
                            //     state: false,
                            //     warningType: null,
                            //     deleteDocIds: [],
                            // })
                            submitAfterSaveWarning(submitWarning?.formValues);
                        }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Save & Continue'} />
                        <MeritoButton size="lg" onClick={() => {
                            // submitBankStatementData();
                            setSubmitWarning({
                                state: false,
                                formValues: null,
                            })
                        }} isRounded={true} btnType="button" type="primary-1" btnText="Continue Editing" />
                    </div>
                </div>
            </ConfirmDialog>

            <div className={styles.liveSupport}>
                <div className={styles.greenDot} />
                <MeritoButton type='primary-1' size='md2' icon={<BiSupport />} btnText="Live Support" onClick={() => setIsSupportOpen(true)} />
            </div>

            <LiveSupport isOpen={isSupportOpen} setIsOpen={setIsSupportOpen} />



            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={showConnectAccountsWarning}
                toggle={() => {
                    setShowConnectAccountsWarning(!showConnectAccountsWarning);
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            Are These Your Only Active Sales and Ad Channels?
                            <br />
                            <br />
                        </div>
                    </div>

                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => {
                            setShowConnectAccountsWarning(false)
                        }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Connect More'} />
                        <MeritoButton size="lg" onClick={() => {
                            setShowConnectAccountsWarning(false)
                            submitFormData();
                        }} isRounded={true} btnType="button" type="primary-1" btnText="Confirm" />
                    </div>
                </div>
            </ConfirmDialog>
        </div>
    );
}

export default MonthlyReportSections;